import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { SearchLiteraturesCounterPaginationComponent } from './search-page-counter-pagination.component';

@NgModule({
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchLiteraturesCounterPagination: {
          component: SearchLiteraturesCounterPaginationComponent,
        },
      },
    }),
  ],
})
export class SearchLiteraturesCounterPaginationModule {}
